import React from 'react';
import { formatNotificationDate } from 'utils/dateUtils';
import { GroupData } from '../helpers';

interface GroupDetailsProps {
  groupData?: GroupData;
  onViewNotification?: (notificationId: string) => void;
}

const GroupDetails: React.FC<GroupDetailsProps> = ({
  groupData,
  onViewNotification
}) => {
  if (!groupData) {
    return (
      <div className="bg-greyWhite rounded-lg p-6">
        <div className="text-center text-darkGray80">
          Carregando dados do grupo...
        </div>
      </div>
    );
  }

  const handleViewNotification = (notificationId: string) => {
    if (onViewNotification) {
      onViewNotification(notificationId);
    }
  };

  return (
    <div className="bg-greyWhite rounded-lg">
      {/* Header com detalhes do grupo */}
      <div className="p-4 rounded-t-lg">
        <h2 className="text-base font-semibold text-darkGray mb-4">Detalhes do grupo</h2>
        <hr className="mb-4 border-[1px] border-[#EBEDF2]" />
        <div className="space-y-3 text-sm">
          <div>
            <p className="text-darkGray font-semibold">
              {groupData.group_info?.u_group_damage_rating?.display_value || 'Não informado'}
            </p>
          </div>

          <div>
            <p className="text-darkGray80 text-xs mb-1">Incidente do grupo</p>
            <p className="text-darkGray font-semibold">
              {groupData.group_info?.u_incident_type?.display_value || 'Não informado'}
            </p>
          </div>

          <div>
            <p className="text-darkGray80 text-xs mb-1">Unidade</p>
            <p className="text-darkGray font-semibold">
              {groupData.group_info?.u_location?.display_value || 'Não informado'}
            </p>
          </div>

          <div>
            <p className="text-darkGray80 text-xs mb-1">Setor</p>
            <p className="text-darkGray font-semibold">
              {groupData.group_info?.u_sector?.display_value || 'Não informado'}
            </p>
          </div>

          <div>
            <p className="text-darkGray80 text-xs mb-1">Chave do grupo</p>
            <p className="text-darkGray font-semibold">
              {groupData.group_info?.u_number?.display_value || 'Não informado'}
            </p>
          </div>
        </div>
      </div>
      <hr className="mx-4 border-[1px] border-[#EBEDF2]" />
      {/* Seção de notificações */}
      <div className="p-4">
        <h3 className="text-blueTheme font-semibold text-base mb-1">Notificações do grupo</h3>
        <span className="bg-[#D9D9D9] text-darkGray px-2 py-1 rounded-full text-[13px]">
          {groupData?.total_notifications || 0} notificações
        </span>

        {/* Tabela de notificações - mesmo padrão da tela de grupo */}
        <div className="outline outline-2 outline-[#E0E0E0] mt-4">
          {/* Cabeçalho da tabela */}
          <div className="bg-[#EEEEF4] divide-x-2 divide-[#E0E0E0]">
            <div className="grid grid-cols-2 gap-0">
              <div className="text-center py-[10.5px] text-[13px] font-semibold text-darkGray border-r-2 border-[#E0E0E0]">
                Título do incidente
              </div>
              <div className="text-center py-[10.5px] text-[13px] font-semibold text-darkGray">
                Ação
              </div>
            </div>
          </div>

          {/* Linhas da tabela */}
          <div className="bg-white divide-y divide-[#E0E0E0]">
            {!groupData.notifications || groupData.notifications.length === 0 ? (
              <div className="py-8 px-4 text-center text-darkGray80">
                Nenhuma notificação encontrada para este grupo
              </div>
            ) : (
              groupData.notifications.map((notification, index) => (
                <div
                  key={notification.sys_id?.value || notification.number.value || index}
                  className="grid grid-cols-2 gap-0 hover:bg-gray-50"
                >
                  <div className="py-[6px] px-4 text-xs text-textSelect leading-relaxed border-r border-[#E0E0E0]">
                    {notification.incident_title?.display_value || 'Sem título'}
                  </div>
                  <div className="py-[6px] px-4 text-center">
                    <button
                      onClick={() => handleViewNotification(notification.sys_id?.value || notification.number.value)}
                      className="text-blueTheme hover:text-blue-700 text-xs font-semibold underline"
                    >
                      Ver dados
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupDetails;